import React from 'react';
import { ArticleSection } from '@sections/Help-Center-Sections/article-section';
import { TroublesSection } from '@sections/Help-Center-Sections/troubles-section';
import { VideoSection } from '@sections/Help-Center-Sections/video-section';
import { HotkeysSection } from '@sections/Help-Center-Sections/hotkeys-section';
import { LearningSection } from '@sections/Help-Center-Sections/learning-section';
import { HELP_CENTER } from '@constants';

export const HelpSectionPage = ({ data, section }) => {
  let SectionView;
  switch (section) {
    case `${HELP_CENTER.VIDEOS}`:
      SectionView = VideoSection;
      break;
    case `${HELP_CENTER.KEYBOARD_SHORTCUTS}`:
      SectionView = HotkeysSection;
      break;
    case `${HELP_CENTER.LEARNING_MODULES}`:
      SectionView = LearningSection;
      break;
    case `${HELP_CENTER.TROUBLES}`:
      SectionView = TroublesSection;
      break;
    default:
      SectionView = ArticleSection;
  }

  return <SectionView data={data} />;
};
